<template>
  <div class="outline" v-for="item in lineList" :key="item.lineID">
    <ul>
      <li>
        <RouterLink
          target="_blank"
          :to="`/examline/linedetail?clID=${item.clID}&lineID=${item.lineID}`"
          >{{ item.lineName }}</RouterLink
        ><i style="font-size: 25px" class="iconfont icon-youjiantou"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    lineList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.outline {
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      display: flex;
      align-items: center;

      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      & :hover {
        cursor: pointer;
        color: @shColor;
      }
      i {
        line-height: 50px;
      }
      //background: #dedede;
    }
  }
}
</style>
